// Checking if the product was added to the cart in a previous page load and announcing it
if (window.location.pathname === '/cart') {
  const cartItems = document.querySelector('cart-items');
  if (!cartItems.classList.contains('is-empty')) {
    setTimeout(() => {
      const ymal = localStorage.getItem('ymal');
      if (ymal === 'added') {
        announceCartUpdate();
        localStorage.removeItem('ymal');
      }
    }, 1500);
  }
}

function addToCart(thisEle, config) {
  if (thisEle.cart) {
    thisEle.cart.announceCartAdding();
  } else {
    announceCartAdding();
    localStorage.setItem('ymal', 'added');
  }
  fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
      if (
        response &&
        response.selling_plan_allocation &&
        response.properties._tracker_id
      ) {
        document.location.href = '/cart/checkout';
        return;
      }
      if (response.status) {
        thisEle.handleErrorMessage(response.description);

        const soldOutMessage =
          thisEle.submitButton.querySelector('.sold-out-message');
        if (!soldOutMessage) return;
        thisEle.submitButton.setAttribute('aria-disabled', true);
        thisEle.submitButton.setAttribute('disabled', true);
        thisEle.submitButton.querySelector('span').classList.add('hidden');
        soldOutMessage.classList.remove('hidden');
        thisEle.error = true;
        return;
      } else if (!thisEle.cart) {
        window.location = window.routes.cart_url;
        return;
      }
      thisEle.error = false;
      if (thisEle.cart) {
        thisEle.cart.announceCartAdding('Product is added to the cart');
      } else {
        announceCartAdding('Product is added to the cart');
      }
      const quickAddModal = thisEle.closest(
        'quick-add-modal, petivity-quick-view',
      );
      if (quickAddModal) {
        document.body.addEventListener(
          'modalClosed',
          () => {
            setTimeout(() => {
              thisEle.cart.renderContents(response);
              if (
                thisEle.cart?.tagName === 'CART-DRAWER' &&
                typeof thisEle.cart.announceCartUpdate === 'function'
              ) {
                setTimeout(() => {
                  if (thisEle.cart) {
                    thisEle.cart.announceCartUpdate();
                  } else {
                    announceCartUpdate();
                  }
                }, 1500);
              }
            });
          },
          {once: true},
        );
        quickAddModal.hide(true);
      } else {
        thisEle.cart.renderContents(response);
      }
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      thisEle.submitButton.classList.remove('loading');
      if (thisEle.cart && thisEle.cart.classList.contains('is-empty'))
        thisEle.cart.classList.remove('is-empty');
      if (!thisEle.error) {
        thisEle.submitButton.removeAttribute('aria-disabled');
        thisEle.submitButton.removeAttribute('disabled');
      }
      const spinner = thisEle.querySelector('.loading-overlay');
      if (spinner) {
        spinner.classList.add('hidden');
      }
    });
}
function clearCart(thisEle, config) {
  fetch(`${routes.cart_clear_url}`, config)
    .then((response) => {
      if (response.status === 200) {
        addToCart(thisEle, config);
      } else {
        console.error('Failed to clear cart');
      }
    })
    .catch((e) => {
      console.error(e);
    });
}
function constructLteAttributes() {
  const date = new Date();
  const current = date.toISOString();
  let futureDate = false;
  const sellingPlanName = document.getElementById('_selling_plan_name');
  let intervalNumber = 1;
  if (
    sellingPlanName &&
    sellingPlanName.value.toLowerCase().includes('month')
  ) {
    date.setMonth(date.getMonth() + 1);
    futureDate = date.toISOString();
    intervalNumber = 1;
  } else if (
    sellingPlanName &&
    sellingPlanName.value.toLowerCase().includes('year')
  ) {
    const year = new Date(new Date().setFullYear(new Date().getFullYear() + 1));
    futureDate = year.toISOString();
    intervalNumber = 12;
  }
  // Set subscription interval line item properties (monthly: 1 month, annual: 12 months)
  const intervalUnitEl = document.getElementById('_interval_unit');
  const intervalNumberEl = document.getElementById('_interval_number');
  const gracePeriodDaysEl = document.getElementById('_grace_period_days');
  if (intervalUnitEl) intervalUnitEl.value = 'month';
  if (intervalNumberEl) intervalNumberEl.value = String(intervalNumber);
  const gracePeriodDays = window.gracePeriodDays;
  const gracePeriodValue = gracePeriodDays != null && gracePeriodDays > 0 ? gracePeriodDays : 3;
  if (gracePeriodDaysEl) gracePeriodDaysEl.value = String(gracePeriodValue);
  if (futureDate) {
    document.getElementById('_est_start_date').value = current;
    document.getElementById('_est_end_date').value = futureDate;

    // Add grace period if global variable exists
    const gracePeriodDays = window.gracePeriodDays;
    if (gracePeriodDays && gracePeriodDays > 0) {
      const endDate = new Date(futureDate);
      endDate.setDate(endDate.getDate() + gracePeriodDays);
      document.getElementById('_est_end_date').value = endDate.toISOString();
    }
  }
}
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');
        this.submitButton =
          this.querySelector('[type="submit"]') ||
          this.querySelector('[data-update-cart-item]');

        constructLteAttributes();
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.setAttribute('disabled', true);
        this.submitButton.classList.add('loading');
        const spinner = this.querySelector('.loading-overlay');
        if (spinner) {
          spinner.classList.remove('hidden');
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData(this.form);

        let sellingPlan = formData.get('selling_plan');
        // Recharge injects the native `selling_plan` field into the form via
        // its storefront widget. In some contexts (e.g. the in-app webview, a
        // blocked CDN, or a tap before the widget initializes) that injection
        // does not happen, which makes the cart add fail with
        // "Variant can only be purchased with a selling plan". Fall back to the
        // server-rendered selling plan id so subscription-only variants can
        // always be added to cart.
        if (!sellingPlan || sellingPlan.trim() === '') {
          const fallbackSellingPlanEl = this.querySelector('#_selling_plan_id');
          const fallbackSellingPlanId = fallbackSellingPlanEl
            ? fallbackSellingPlanEl.value.trim()
            : '';
          if (fallbackSellingPlanId) {
            formData.set('selling_plan', fallbackSellingPlanId);
            sellingPlan = fallbackSellingPlanId;
          }
        }
        const isSubscription = !!(sellingPlan && sellingPlan.trim() !== '');
        if (isSubscription) {
          formData.set('properties[_is_subscription]', 'true');
        }

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id),
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        if (
          formData.get('selling_plan') &&
          formData.get('properties[_tracker_id]')
        ) {
          clearCart(this, config);
        } else {
          addToCart(this, config);
        }
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message',
          );

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );
}

function announceCartUpdate() {
  const announcement = document.querySelector('#Cart-UpdateAnnouncement');
  if (!announcement) return;

  const countElement = document.querySelector(
    '.global-header__utility-link--cart-bubble [aria-hidden]',
  );
  const subtotalElement = document.querySelector('.totals__subtotal-value');
  const itemCount = countElement ? parseInt(countElement.textContent, 10) : 0;
  const itemText = itemCount === 1 ? 'item' : 'items';
  const subtotalText = subtotalElement
    ? subtotalElement.textContent.trim()
    : '';
  const message = subtotalText
    ? `Cart updated. ${itemCount} ${itemText} in cart. Subtotal ${subtotalText}.`
    : `Cart updated. ${itemCount} ${itemText} in cart.`;

  announcement.textContent = '';
  if (itemCount) {
    setTimeout(() => {
      announcement.textContent = message;
      setTimeout(() => {
        announcement.textContent = '';
      }, 3000);
    }, 200);
  }
}

function announceCartAdding(message = 'Adding product to the cart') {
  const announcement = document.querySelector('#Cart-UpdateAnnouncement');
  if (!announcement) return;

  announcement.textContent = '';

  setTimeout(() => {
    announcement.textContent = message;
    setTimeout(() => {
      announcement.textContent = '';
    }, 2000);
  }, 200);
}
